module.exports = __webpack_public_path__ + "img/10.ce4b4732.jpg";